import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

export type MatSnackBarActions = 'OK' | 'Close' | 'Undo' | 'Retry' | 'Cancel' | 'Yes' | 'No' | 'Help' | 'View' | 'Details' | 'Delete'
export type MatNotifications = 'success' | 'error' | 'info' | 'warning'

export interface NotificationOptions {
  message: string;
  horizontalPosition?: MatSnackBarHorizontalPosition
  verticalPosition?: MatSnackBarVerticalPosition
  action?: MatSnackBarActions
  durationSeconds?: number
  notificationType?: MatNotifications
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private snackBar: MatSnackBar
  ) { }

  public notify(options: NotificationOptions): void {
    this.snackBar.open(options.message, options.action || 'OK', {
      duration: options.durationSeconds || 3 * 1000,
      horizontalPosition: options.horizontalPosition || 'right',
      verticalPosition: options.verticalPosition || 'top',
      panelClass: ['notification', options.notificationType || 'success']
    });
  }
}
